/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import Package from "../../package.json";

export const getVersion = () => {
    const version  = Package.version;
    return version;
};
